import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { TenantThemeProvider } from "./theme/TenantThemeProvider";
import { ToastProvider } from "./contexts";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TenantThemeProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </TenantThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
